import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:3001";

export const authClient = createAuthClient({
  baseURL: `${API_BASE_URL}/api/auth`,
  plugins: [
    organizationClient({
      schema: {
        organization: {
          additionalFields: {
            tenantId: {
              type: "string",
              required: true,
            },
            parentId: {
              type: "string",
              required: false,
            },
          },
        },
      },
    }),
  ],
});
